<template>
  <div id="events-preview">
    <v-overlay :value="ProgressLoadingFlag">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Premium Header Card with Professional Design -->
    <v-card elevation="20" class="header-card mb-6 overflow-hidden">
      <div class="header-gradient">
        <div class="header-backdrop-effect"></div>
        <div class="header-content pa-8">
          <v-row align="center" justify="space-between">
            <!-- Left Side: Title and Icon -->
            <v-col cols="12" md="8" class="d-flex align-center">
              <div class="header-icon-box">
                <v-icon size="40px" color="white"
                  >mdi-message-reply-text</v-icon
                >
              </div>
              <div class="ml-4">
                <h1 class="header-title white--text mb-0">
                  Support Ticket Details
                </h1>
                <p class="header-subtitle white--text mb-0">
                  View ticket information and communicate with support team
                </p>
              </div>
            </v-col>

            <!-- Right Side: Action Buttons -->
            <v-col cols="12" md="4" class="text-right">
              <v-btn
                icon
                class="action-btn"
                @click="refreshPageData"
                title="Refresh"
              >
                <v-icon>mdi-refresh</v-icon>
              </v-btn>
              <v-btn
                icon
                class="action-btn ml-2"
                @click="closePrompt"
                title="Close"
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-card>
    <v-card>
      <v-card-text>
        <div class="d-flex justify-content-center mb-3" v-if="LoadingFlag">
          <v-progress-circular
            indeterminate
            size="48"
            color="#0097d7"
          ></v-progress-circular>
        </div>

        <v-form
          ref="form1"
          v-model="valid1"
          lazy-validation
          v-on:submit.prevent="submitForm"
        >
          <!-- Ticket Information Section -->
          <v-card elevation="8" class="info-card mb-6" v-if="ResponseFlag">
            <v-container class="pa-6">
              <v-row>
                <v-col cols="12">
                  <div class="section-header">
                    <h3 class="section-title">
                      <v-icon color="#0097d7" class="mr-2"
                        >mdi-information</v-icon
                      >
                      Ticket Information
                    </h3>
                  </div>
                </v-col>
              </v-row>

              <!-- Primary Info - Ticket ID and Status -->
              <v-row wrap class="mb-6">
                <v-col cols="12" sm="6" lg="3" md="3">
                  <div class="info-box primary">
                    <div class="info-icon">
                      <v-icon color="white">mdi-pound</v-icon>
                    </div>
                    <div class="info-content">
                      <p class="info-label">Ticket ID</p>
                      <p class="info-value">{{ row.ReferenceNo }}</p>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3" md="3">
                  <div class="info-box status">
                    <div class="info-icon">
                      <v-icon color="white">mdi-check-circle</v-icon>
                    </div>
                    <div class="info-content">
                      <p class="info-label">Status</p>
                      <div class="status-badge" :class="getStatusClass(row.ActiveStatus)">
                        {{ getStatusText(row.ActiveStatus) }}
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3" md="3">
                  <div class="info-box">
                    <div class="info-icon">
                      <v-icon color="#0097d7">mdi-calendar-multiple</v-icon>
                    </div>
                    <div class="info-content">
                      <p class="info-label">Created Date</p>
                      <p class="info-value">{{ row.CreatedAtTxt }}</p>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="3" md="3">
                  <div class="info-box">
                    <div class="info-icon">
                      <v-icon color="#0097d7">mdi-tag-multiple</v-icon>
                    </div>
                    <div class="info-content">
                      <p class="info-label">Type</p>
                      <p class="info-value">{{ row.TypeName }}</p>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!-- Secondary Info - Department and Subject -->
              <v-row wrap>
                <v-col cols="12" sm="6" lg="3" md="3">
                  <div class="info-box">
                    <div class="info-icon">
                      <v-icon color="#0097d7">mdi-office-building</v-icon>
                    </div>
                    <div class="info-content">
                      <p class="info-label">Department</p>
                      <p class="info-value">{{ row.DepartmentName }}</p>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <v-row wrap class="mt-6">
                <v-col cols="12" sm="6" lg="6" md="6">
                  <div class="detail-box">
                    <p class="detail-label">
                      <v-icon small color="#0097d7" class="mr-2"
                        >mdi-pencil</v-icon
                      >
                      Subject
                    </p>
                    <p class="detail-value">{{ row.Subject }}</p>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="6" md="6">
                  <div class="detail-box">
                    <p class="detail-label">
                      <v-icon small color="#0097d7" class="mr-2"
                        >mdi-text</v-icon
                      >
                      Content
                    </p>
                    <p class="detail-value">{{ row.Contnet }}</p>
                  </div>
                </v-col>
              </v-row>

              <v-row wrap class="mt-4" v-if="row.AttachmentImage !== ''">
                <v-col cols="12">
                  <div class="detail-box">
                    <p class="detail-label">
                      <v-icon small color="#0097d7" class="mr-2"
                        >mdi-image</v-icon
                      >
                      Attachments
                    </p>
                    <div class="attachments-container">
                      <viewer rebuild :images="row.AllImages">
                        <img
                          class="attachment-img"
                          :src="src"
                          :key="src"
                          v-for="src in row.AllImages"
                        />
                      </viewer>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card>

          <!-- Message Section with WhatsApp-like chat interface -->
          <v-card
            elevation="8"
            class="messages-card mb-6"
            v-if="
              ResponseFlag && row.ResponseArray && row.ResponseArray.length > 0
            "
          >
            <v-container class="pa-6">
              <v-row>
                <v-col cols="12">
                  <h3 class="section-title">
                    <v-icon color="#0097d7" class="mr-2"
                      >mdi-chat-processing</v-icon
                    >
                    Message Details
                  </h3>
                </v-col>
              </v-row>

              <!-- Chat Container -->
              <div class="chat-container">
                <div
                  v-for="msg in row.ResponseArray"
                  :key="msg.ResponseId"
                  class="message-wrapper"
                  :class="{
                    'sender-message': msg.Sender == 1,
                    'receiver-message': msg.Sender != 1,
                  }"
                >
                  <div class="message-bubble">
                    <div class="message-header">
                      <span class="message-sender">{{
                        msg.ResponseByNameTxt
                      }}</span>
                      <span class="message-time">{{
                        msg.ResponseCreatedAT
                      }}</span>
                    </div>
                    <div class="message-content">
                      {{ msg.ResponseMessageTxt }}
                    </div>
                    <div
                      class="message-attachments"
                      v-if="msg.ResponseAttachmentImage !== ''"
                    >
                      <viewer rebuild :images="msg.ResponseAllImages">
                        <img
                          class="message-img"
                          :src="src"
                          :key="src"
                          v-for="src in msg.ResponseAllImages"
                        />
                      </viewer>
                    </div>
                  </div>
                </div>
              </div>
            </v-container>
          </v-card>

          <!-- Reply Section -->
          <v-card
            elevation="8"
            class="reply-card"
            v-if="ResponseFlag && row.ActiveStatus"
          >
            <v-container class="pa-6">
              <v-row>
                <v-col cols="12">
                  <h3 class="section-title">
                    <v-icon color="#0097d7" class="mr-2"
                      >mdi-pencil-plus</v-icon
                    >
                    Write Message
                  </h3>
                </v-col>
              </v-row>

              <v-row wrap>
                <v-col cols="12">
                  <div class="form-field-wrapper">
                    <label class="form-label">
                      <v-icon small color="#0097d7">mdi-message-text</v-icon>
                      Message
                    </label>
                    <v-textarea
                      v-model="Content"
                      placeholder="Type your message here..."
                      required
                      outlined
                      dense
                      rows="4"
                      :rules="ContentRules"
                      class="custom-textarea"
                    ></v-textarea>
                  </div>
                </v-col>
              </v-row>

              <v-row wrap class="mt-4">
                <v-col cols="12" sm="6" lg="6" md="6">
                  <div class="form-field-wrapper">
                    <label class="form-label">
                      <v-icon small color="#0097d7">mdi-image-plus</v-icon>
                      Upload Attachment
                    </label>
                    <p class="notes-text">
                      <v-icon x-small color="#0097d7"
                        >mdi-information-outline</v-icon
                      >
                      (only jpg, png image files are accepted)
                    </p>
                    <v-file-input
                      :clearable="false"
                      truncate-length="25"
                      accept="image/png, image/jpeg"
                      placeholder="Click to upload or drag image"
                      prepend-icon="mdi-cloud-upload-outline"
                      v-model="UploadedImage1"
                      @change="addImage(1)"
                      class="custom-input"
                    >
                    </v-file-input>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" lg="6" md="6">
                  <div class="form-field-wrapper">
                    <label class="form-label">
                      <v-icon small color="#0097d7">mdi-image</v-icon>
                      Preview
                    </label>
                    <div class="preview-box" v-if="SelectedImage1.ImageUrl">
                      <cropper ref="cropper" :src="SelectedImage1.ImageUrl" />
                      <v-btn
                        icon
                        small
                        color="error"
                        @click="deleteImage(1)"
                        class="delete-btn"
                        title="Delete image"
                      >
                        <v-icon>mdi-delete</v-icon>
                      </v-btn>
                    </div>
                    <div class="preview-empty" v-else>
                      <v-icon size="48" color="#ccc">mdi-image-multiple</v-icon>
                      <p class="mt-2 text-muted">No image selected</p>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <v-row wrap class="mt-6">
                <v-col align="center" cols="12" md="12">
                  <v-btn
                    @click.prevent="uploadImage(1)"
                    elevation="8"
                    rounded
                    large
                    color="#56bda3"
                    class="px-10 font-weight-bold white--text mr-3"
                  >
                    <v-icon left>mdi-send</v-icon>
                    Reply
                  </v-btn>

                  <v-btn
                    @click.prevent="uploadImage(0)"
                    elevation="8"
                    rounded
                    large
                    color="#3a67b1"
                    class="px-10 font-weight-bold white--text mr-3"
                  >
                    <v-icon left>mdi-check-all</v-icon>
                    Reply & Close
                  </v-btn>

                  <v-btn
                    @click.prevent="closePrompt"
                    elevation="8"
                    rounded
                    large
                    color="#56bda3"
                    class="px-10 font-weight-bold white--text"
                  >
                    <v-icon left>mdi-close</v-icon>
                    Exit
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>
  
  <script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {},
  props: {
    previewRecordFlag: {
      type: Boolean,
      required: true,
    },
    recordData: {
      required: true,
    },
    pageTitle: {
      type: String,
    },
  },

  data() {
    return {
      Width: 500,

      valid1: false,
      valid2: false,
      ProgressLoadingFlag: false,
      ResultFlag: false,
      LoadingFlag: false,
      row: {},
      PaymentDetails: {},
      selected: [],
      ResponseFlag: false,
      // ImageFlag: false,
      // ImageFlag1: false,
      // ImageFlag2: false,

      Content: "",
      ContentRules: [(v) => !!v || "Message is required"],
      UploadedImage1: {},
      SelectedImage1: { src: null },

      dialog: false,
      dialog1: false,

      tableColumns: [],
      tableOptions: [],
      tableData: [],
    };
  },
  computed: {},
  watch: {},
  created() {
    // this.initialize()
  },
  methods: {
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hidePreviewRecordPrompt", this.ResultFlag);
    },
    refreshPageData() {
      console.log("refreshPageData called");
      var recordData = this.recordData;
      console.log("recordData=" + JSON.stringify(recordData));
      this.getTableRecords();
    },
    getStatusText(status) {
      return status == 1 ? "Active" : "Closed";
    },
    getStatusClass(status) {
      return status == 1 ? "active" : "closed";
    },
    // openImage() {
    //   console.log("openImage called");
    //   this.ImageFlag = true;
    // },
    // openImage1() {
    //   console.log("openImage1 called");
    //   this.ImageFlag1 = true;
    // },
    // openImage2() {
    //   console.log("openImage1 called");
    //   this.ImageFlag2 = true;
    // },
    getTableRecords() {
      console.log("getTableRecords called");

      var ReferenceNo = this.recordData.ReferenceNo;
      var FromUserId = this.recordData.FromUserId;
      var DepartmentId = this.recordData.DepartmentId;
      var TypeId = this.recordData.TypeId;
      var CreatedAtTxt = this.recordData.CreatedAtTxt;
      var UpdatedAtTxt = this.recordData.UpdatedAtTxt;
      var UserInterface = 1;
      console.log(
        ", ReferenceNo=" +
          ReferenceNo +
          ", FromUserId=" +
          FromUserId +
          ", DepartmentId=" +
          DepartmentId +
          ", TypeId=" +
          TypeId +
          ", CreatedAtTxt=" +
          CreatedAtTxt +
          ", UpdatedAtTxt=" +
          UpdatedAtTxt
      );

      if (UserInterface != "") {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/ticket/show";
        var upload = {
          UserInterface: UserInterface,
          FromUserId: FromUserId,
          ReferenceNo: ReferenceNo,
          DepartmentId: DepartmentId,
          TypeId: TypeId,
          CreatedAtTxt: CreatedAtTxt,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.row = {};
        this.ResultFlag = false;
        this.ResponseFlag = false;

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        this.LoadingFlag = true;
        this.Documentpath = "";

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            thisIns.LoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            thisIns.ResponseFlag = flag;

            if (flag == 1) {
              thisIns.row = records;
              console.log("records=" + JSON.stringify(records));
              // thisIns.toast("success", output);
            } else {
              // thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.toast("error", error);
            thisIns.LoadingFlag = false;
            thisIns.ResponseFlag = false;
          });
      } else {
        var message = "Your session is expired. Kindly login again. ";
        console.log("error=" + message);
      }
    },
    addImage(id) {
      console.log("addImage called");
      console.log({ id });
      switch (id) {
        case 1:
          var file = this.UploadedImage1;
          console.log({ file });
          var src = URL.createObjectURL(file);
          console.log({ src });
          if (this.SelectedImage1.src) {
            URL.revokeObjectURL(this.SelectedImage1.src);
          }
          var FileType = file.type;
          console.log({ FileType });
          this.SelectedImage1 = {
            ImageName: file.name,
            ImageType: FileType,
            ImageUrl: src,
            UploadedImage: file,
          };
          break;

        default:
          break;
      }
    },
    deleteImage(id) {
      console.log("deleteImage called");
      console.log({ id });
      switch (id) {
        case 1:
          this.SelectedImage1 = {
            ImageName: null,
            ImageType: null,
            ImageUrl: null,
            UploadedImage: null,
          };
          this.UploadedImage1 = {};
          break;

        default:
          break;
      }
    },
    uploadImage(status) {
      console.log("uploadImage called");
      var Status = status;
      console.log("Status = " + Status);
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        const formData = new FormData();
        formData.append("TicketId", this.row.TicketId);
        formData.append("Content", this.Content);
        formData.append("Status", Status);
        var UploadedImageName = this.UploadedImage1.name;
        UploadedImageName =
          UploadedImageName == (null || undefined) ? "" : UploadedImageName;
        if (UploadedImageName != "") {
          const { canvas } = this.$refs.cropper.getResult();
          if (canvas) {
            canvas.toBlob((blob) => {
              formData.append("UploadedFile1", blob, UploadedImageName);
              this.UploadFlag = true;
              this.submitForm(formData);
            }, "image/jpeg");
          } else {
            this.submitForm(formData);
          }
        } else {
          this.submitForm(formData);
        }
      } else {
        var message = "";
        if (validate1 == false) {
          message += "Kindly fill the required fields. ";
        }
        if (MemberId == 0) {
          message += "Kindly select member. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
    submitForm(upload) {
      console.log("submitForm is called");
      this.ProgressLoadingFlag = true;

      var server_url = companyConfig.apiURL;
      var token = this.$session.get("token");
      token = token == (null || undefined) ? 0 : token;
      var add_url = server_url + "api/ticket-response/store";

      console.log("upload=" + JSON.stringify(upload));
      console.log(
        "server_url=" + server_url + ", token=" + token + ", add_url=" + add_url
      );

      const thisIns = this;
      var output = "";
      var records = {};
      var table = {};
      var successTxt = "";
      var errorTxt = "";
      var flag = 0;
      this.ResultFlag = false;

      this.$http({
        url: add_url,
        method: "POST",
        data: upload,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: "Bearer " + token,
        },
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(
            Math.round((progressEvent.loaded / progressEvent.total) * 100)
          );
        }.bind(this),
      })
        .then(function (response) {
          console.log("response=" + JSON.stringify(response));

          thisIns.ProgressLoadingFlag = false;

          output = response.data.output;
          flag = response.data.flag;
          output = response.data.output;
          records = response.data.records;
          console.log("output=" + output + ", flag=" + flag);
          successTxt = response.data.success;
          errorTxt = response.data.error;
          console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);
          thisIns.ResultFlag = true;

          if (flag == 1) {
            thisIns.sweetAlert("success", output, true);
            thisIns.refreshPageData();
            thisIns.Content = "";
            thisIns.deleteImage(1);
            // thisIns.$emit("hideEditRecordPrompt");
          } else {
            thisIns.sweetAlert("error", output, false);
            //   thisIns.getTableRecords();
          }
        })
        .catch(function (error) {
          console.log("error=" + error);
          thisIns.SearchFlag = false;
          thisIns.ProgressLoadingFlag = true;
          thisIns.ResultFlag = false;
        });
    },
  },
  beforeMount() {
    this.refreshPageData();
  },
};
</script>
  <style lang="scss" scoped>
// Color Palette (JCI Approved Colors)
$navy: #3a67b1;
$aqua: #0097d7;
$gold: #edbe38;
$seaform: #56bda3;
$text-90-black: #414042;
$text-off-black: #0a0f29;
$text-white: #ffffff;
$light-bg: #f8fafc;
$border-color: rgba(0, 151, 215, 0.15);
$text-primary: #414042;
$text-secondary: #414042;

// Keyframe Animations
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes chatSlideIn {
  from {
    opacity: 0;
    transform: translateY(20px) scale(0.9);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

// Main Container
#events-preview {
  background: $light-bg;
  padding: 20px;
  min-height: 100vh;

  // ============ HEADER CARD ============
  .header-card {
    background: linear-gradient(
      135deg,
      $navy 0%,
      $aqua 50%,
      $navy 100%
    ) !important;
    border-radius: 20px;
    overflow: hidden;
    animation: slideDown 0.8s cubic-bezier(0.34, 1.56, 0.64, 1);
    position: relative;
    border: none;
    box-shadow: 0 20px 60px rgba(58, 103, 177, 0.5),
      0 0 40px rgba(0, 151, 215, 0.3);

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        45deg,
        transparent 30%,
        rgba(255, 255, 255, 0.1) 50%,
        transparent 70%
      );
      animation: shimmer 3s infinite;
    }

    .header-gradient {
      position: relative;
      z-index: 1;
    }

    .header-backdrop-effect {
      position: absolute;
      top: -50%;
      right: -50%;
      width: 200%;
      height: 200%;
      background: radial-gradient(
        circle,
        rgba(255, 255, 255, 0.15) 0%,
        transparent 70%
      );
      animation: rotate 25s linear infinite;
    }

    .header-content {
      position: relative;
      z-index: 2;
    }

    .header-icon-box {
      background: linear-gradient(
        135deg,
        rgba(255, 255, 255, 0.25) 0%,
        rgba(255, 255, 255, 0.15) 100%
      );
      backdrop-filter: blur(15px);
      border-radius: 18px;
      padding: 14px;
      box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2),
        inset 0 1px 0 rgba(255, 255, 255, 0.4);
      animation: float 4s ease-in-out infinite;
      border: 2px solid rgba(255, 255, 255, 0.3);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .header-title {
      font-size: 36px;
      font-weight: 900;
      text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3),
        0 0 20px rgba(0, 151, 215, 0.3);
      animation: slideInLeft 0.8s ease-out;
      letter-spacing: 0.8px;
      color: $text-white;
      margin: 0;
    }

    .header-subtitle {
      font-size: 17px;
      opacity: 0.98;
      animation: slideInLeft 1s ease-out 0.1s backwards;
      letter-spacing: 0.4px;
      color: $text-white;
      font-weight: 500;
      margin: 0;
    }

    .action-btn {
      transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
      font-weight: 700;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      background: rgba(255, 255, 255, 0.15) !important;
      border: 2px solid rgba(255, 255, 255, 0.3) !important;
      backdrop-filter: blur(10px);
      color: white !important;

      &:hover {
        transform: translateY(-4px);
        box-shadow: 0 12px 24px rgba(0, 0, 0, 0.3) !important;
        background: rgba(255, 255, 255, 0.25) !important;
      }

      &:active {
        transform: translateY(0);
      }
    }
  }

  // ============ INFO CARD ============
  .info-card {
    border-radius: 16px;
    border: 1px solid $border-color;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    animation: slideDown 0.6s ease-out 0.2s backwards;
    background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);

    .section-header {
      margin-bottom: 8px;
    }

    .section-title {
      color: $navy;
      font-size: 20px;
      font-weight: 700;
      display: flex;
      align-items: center;
      margin: 0 0 24px 0;
      padding-bottom: 16px;
      border-bottom: 3px solid $aqua;
      position: relative;

      &::after {
        content: "";
        position: absolute;
        bottom: -3px;
        left: 0;
        width: 40px;
        height: 3px;
        background: linear-gradient(90deg, $aqua 0%, $seaform 100%);
        border-radius: 3px;
      }
    }

    // Info Boxes
    .info-box {
      display: flex;
      align-items: center;
      background: linear-gradient(
        135deg,
        rgba(0, 151, 215, 0.08) 0%,
        rgba(86, 189, 163, 0.08) 100%
      );
      padding: 20px;
      border-radius: 14px;
      border: 2px solid rgba(0, 151, 215, 0.15);
      transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          135deg,
          transparent 0%,
          rgba(255, 255, 255, 0.3) 50%,
          transparent 100%
        );
        opacity: 0;
        transition: opacity 0.35s ease;
      }

      &:hover {
        background: linear-gradient(
          135deg,
          rgba(0, 151, 215, 0.15) 0%,
          rgba(86, 189, 163, 0.15) 100%
        );
        transform: translateY(-6px);
        border-color: rgba(0, 151, 215, 0.3);
        box-shadow: 0 12px 28px rgba(0, 151, 215, 0.15),
          0 8px 16px rgba(0, 0, 0, 0.08);

        &::before {
          opacity: 1;
        }
      }

      &.primary {
        background: linear-gradient(135deg, $navy 0%, $aqua 100%);
        border: none;
        color: white;

        .info-icon {
          background: rgba(255, 255, 255, 0.25);
        }

        .info-label {
          color: $text-white !important;
        }

        .info-value {
          color: $text-white !important;
        }

        &:hover {
          box-shadow: 0 12px 28px rgba(58, 103, 177, 0.3),
            0 8px 16px rgba(0, 0, 0, 0.1);
          transform: translateY(-6px);
        }
      }

      &.status {
        background: linear-gradient(135deg, $aqua 0%, $seaform 100%);
        border: none;
        color: white;

        .info-icon {
          background: rgba(255, 255, 255, 0.25);
        }

        .info-label {
          color: $text-white !important;
        }

        .info-value {
          color: $text-white !important;
        }

        &:hover {
          box-shadow: 0 12px 28px rgba(0, 151, 215, 0.3),
            0 8px 16px rgba(0, 0, 0, 0.1);
          transform: translateY(-6px);
        }
      }

      .info-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 48px;
        min-height: 48px;
        background: white;
        border-radius: 12px;
        margin-right: 16px;
        box-shadow: 0 4px 12px rgba(0, 151, 215, 0.2);
        flex-shrink: 0;
      }

      .info-content {
        flex: 1;

        .info-label {
          font-size: 10px;
          font-weight: 700;
          color: $text-secondary;
          text-transform: uppercase;
          letter-spacing: 0.8px;
          margin: 0 0 6px 0;
        }

        .info-value {
          font-size: 18px;
          font-weight: 800;
          color: $text-primary;
          margin: 0;
          letter-spacing: -0.5px;
        }
      }
    }

    // Status Badge
    .status-badge {
      display: inline-block;
      padding: 6px 14px;
      border-radius: 20px;
      font-size: 12px;
      font-weight: 700;
      letter-spacing: 0.5px;
      text-transform: uppercase;
      transition: all 0.3s ease;

      &.active {
        background: linear-gradient(135deg, $seaform 0%, rgba(86, 189, 163, 0.9) 100%);
        color: white;
        box-shadow: 0 4px 12px rgba(86, 189, 163, 0.3);

        &::before {
          content: "●";
          margin-right: 6px;
          animation: pulse 2s infinite;
        }
      }

      &.closed {
        background: linear-gradient(135deg, #414042 0%, rgba(65, 64, 66, 0.85) 100%);
        color: white;
        box-shadow: 0 4px 12px rgba(65, 64, 66, 0.3);
      }
    }

    // Detail Boxes
    .detail-box {
      background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);
      padding: 20px;
      border-radius: 14px;
      border: 2px solid $border-color;
      transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
      position: relative;
      overflow: hidden;

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: linear-gradient(90deg, $aqua 0%, $seaform 100%);
        transform: scaleX(0);
        transform-origin: left;
        transition: transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
      }

      &:hover {
        border-color: $aqua;
        box-shadow: 0 12px 28px rgba(0, 151, 215, 0.12),
          0 8px 16px rgba(0, 0, 0, 0.06);
        transform: translateY(-4px);

        &::before {
          transform: scaleX(1);
        }
      }

      .detail-label {
        font-size: 11px;
        font-weight: 800;
        color: $navy;
        text-transform: uppercase;
        letter-spacing: 0.6px;
        margin: 0 0 12px 0;
        display: flex;
        align-items: center;
        gap: 6px;
      }

      .detail-value {
        font-size: 16px;
        color: $text-primary;
        line-height: 1.7;
        margin: 0;
        word-break: break-word;
        font-weight: 500;
      }
    }

    // Attachments Container
    .attachments-container {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;

      .attachment-img {
        width: 100px;
        height: 100px;
        border-radius: 12px;
        object-fit: cover;
        box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
        transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
        cursor: pointer;
        border: 2px solid $border-color;

        &:hover {
          transform: scale(1.1) rotate(3deg);
          box-shadow: 0 12px 28px rgba(0, 151, 215, 0.3);
          border-color: $aqua;
        }
      }
    }
  }

  // ============ MESSAGES CARD ============
  .messages-card {
    border-radius: 16px;
    border: 1px solid $border-color;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    animation: slideDown 0.6s ease-out 0.3s backwards;
    background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);

    .section-title {
      color: $navy;
      font-size: 20px;
      font-weight: 700;
      display: flex;
      align-items: center;
      margin: 0 0 24px 0;
      padding-bottom: 16px;
      border-bottom: 3px solid $aqua;

      &::after {
        content: "";
        position: absolute;
        bottom: -3px;
        left: 0;
        width: 40px;
        height: 3px;
        background: linear-gradient(90deg, $aqua 0%, $seaform 100%);
        border-radius: 3px;
      }
    }

    // Chat Container
    .chat-container {
      display: flex;
      flex-direction: column;
      gap: 18px;
      max-height: 550px;
      overflow-y: auto;
      padding: 16px 8px;
      background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);
      border-radius: 12px;

      // Custom Scrollbar
      &::-webkit-scrollbar {
        width: 8px;
      }

      &::-webkit-scrollbar-track {
        background: $light-bg;
        border-radius: 10px;
      }

      &::-webkit-scrollbar-thumb {
        background: linear-gradient(180deg, $aqua 0%, $seaform 100%);
        border-radius: 10px;

        &:hover {
          background: linear-gradient(180deg, $navy 0%, $aqua 100%);
        }
      }
    }

    // Message Wrapper
    .message-wrapper {
      display: flex;
      animation: chatSlideIn 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);

      &.sender-message {
        justify-content: flex-end;

        .message-bubble {
          background: linear-gradient(135deg, $aqua 0%, #0086c4 100%);
          color: white;
          border-radius: 18px 18px 6px 18px;
          max-width: 75%;
          box-shadow: 0 8px 20px rgba(0, 151, 215, 0.25),
            0 4px 12px rgba(0, 0, 0, 0.1);

          .message-header {
            opacity: 0.92;
            font-size: 11px;
            margin-bottom: 8px;
            letter-spacing: 0.3px;
          }

          .message-sender {
            font-weight: 700;
            letter-spacing: 0.2px;
          }

          .message-time {
            font-size: 10px;
            opacity: 0.75;
            margin-left: 10px;
          }

          .message-content {
            font-size: 15px;
            line-height: 1.6;
            word-break: break-word;
            font-weight: 500;
          }
        }
      }

      &.receiver-message {
        justify-content: flex-start;

        .message-bubble {
          background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
          color: $text-primary;
          border-radius: 18px 18px 18px 6px;
          border: 2px solid $border-color;
          max-width: 75%;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);

          .message-header {
            font-size: 11px;
            margin-bottom: 8px;
            color: $text-secondary;
            letter-spacing: 0.3px;
          }

          .message-sender {
            font-weight: 700;
            color: $navy;
            letter-spacing: 0.2px;
          }

          .message-time {
            font-size: 10px;
            opacity: 0.65;
            margin-left: 10px;
          }

          .message-content {
            font-size: 15px;
            line-height: 1.6;
            word-break: break-word;
            color: $text-primary;
            font-weight: 500;
          }
        }
      }
    }

    // Message Bubble
    .message-bubble {
      padding: 14px 18px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
        transform: translateY(-2px);
      }

      .message-attachments {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        margin-top: 12px;

        .message-img {
          width: 90px;
          height: 90px;
          border-radius: 10px;
          object-fit: cover;
          cursor: pointer;
          transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
          border: 2px solid rgba(255, 255, 255, 0.3);

          &:hover {
            transform: scale(1.12) rotate(-2deg);
            box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
          }
        }
      }
    }
  }

  // ============ REPLY CARD ============
  .reply-card {
    border-radius: 16px;
    border: 1px solid $border-color;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    animation: slideDown 0.6s ease-out 0.4s backwards;
    background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%);

    .section-title {
      color: $navy;
      font-size: 20px;
      font-weight: 700;
      display: flex;
      align-items: center;
      margin: 0 0 24px 0;
      padding-bottom: 16px;
      border-bottom: 3px solid $aqua;

      &::after {
        content: "";
        position: absolute;
        bottom: -3px;
        left: 0;
        width: 40px;
        height: 3px;
        background: linear-gradient(90deg, $aqua 0%, $seaform 100%);
        border-radius: 3px;
      }
    }

    // Form Field Wrapper
    .form-field-wrapper {
      .form-label {
        display: flex;
        align-items: center;
        font-size: 12px;
        font-weight: 800;
        color: $navy;
        margin-bottom: 10px;
        text-transform: uppercase;
        letter-spacing: 0.6px;
        gap: 6px;
      }

      .notes-text {
        font-size: 11px;
        color: $text-secondary;
        margin: 4px 0 12px 0;
        display: flex;
        align-items: center;
        gap: 4px;
        font-weight: 500;
      }
    }

    // Custom Textarea
    .custom-textarea {
      ::v-deep {
        .v-field {
          background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%) !important;
        }

        .v-field__outline {
          border-color: $border-color !important;
          transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }

        &:hover .v-field__outline {
          border-color: rgba(0, 151, 215, 0.4) !important;
        }

        &.v-field--focused .v-field__outline {
          border-color: $aqua !important;
          border-width: 2px !important;
          box-shadow: 0 0 0 4px rgba(0, 151, 215, 0.08) !important;
        }

        textarea {
          font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
          font-size: 15px;
          color: $text-primary;
          line-height: 1.7;
          font-weight: 500;

          &::placeholder {
            color: #cbd5e1;
            opacity: 1;
            font-weight: 400;
          }
        }
      }
    }

    // Custom File Input
    .custom-input {
      ::v-deep {
        .v-field {
          background: linear-gradient(135deg, #ffffff 0%, #f9fafb 100%) !important;
        }

        .v-field__outline {
          border-color: $border-color !important;
          transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1) !important;
        }

        &:hover .v-field__outline {
          border-color: rgba(0, 151, 215, 0.4) !important;
        }

        &.v-field--focused .v-field__outline {
          border-color: $aqua !important;
          border-width: 2px !important;
          box-shadow: 0 0 0 4px rgba(0, 151, 215, 0.08) !important;
        }
      }
    }

    // Preview Box
    .preview-box {
      position: relative;
      border: 2px dashed $aqua;
      border-radius: 14px;
      padding: 12px;
      background: linear-gradient(135deg, rgba(0, 151, 215, 0.05) 0%, rgba(86, 189, 163, 0.05) 100%);
      overflow: hidden;
      transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        background: linear-gradient(135deg, rgba(0, 151, 215, 0.1) 0%, rgba(86, 189, 163, 0.1) 100%);
        border-color: $aqua;
      }

      .delete-btn {
        position: absolute;
        top: 8px;
        right: 8px;
        z-index: 10;
        background: rgba(255, 255, 255, 0.95) !important;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

        &:hover {
          transform: scale(1.15);
          background: white !important;
        }
      }
    }

    .preview-empty {
      border: 2px dashed $border-color;
      border-radius: 14px;
      padding: 32px 24px;
      text-align: center;
      background: linear-gradient(135deg, $light-bg 0%, #f1f5f9 100%);
      transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);

      &:hover {
        border-color: $aqua;
        background: linear-gradient(135deg, rgba(0, 151, 215, 0.02) 0%, rgba(86, 189, 163, 0.02) 100%);
      }

      .text-muted {
        color: $text-secondary;
        font-size: 13px;
        margin: 0;
        font-weight: 500;
      }
    }

    // Action Buttons
    ::v-deep .v-btn {
      border-radius: 12px !important;
      font-weight: 800 !important;
      font-size: 13px !important;
      text-transform: uppercase !important;
      letter-spacing: 0.8px !important;
      transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1) !important;
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15) !important;
      position: relative;
      overflow: hidden;

      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 50%;
        width: 0;
        height: 0;
        border-radius: 50%;
        background: rgba(255, 255, 255, 0.3);
        transform: translate(-50%, -50%);
        transition: width 0.6s, height 0.6s;
      }

      &:hover {
        transform: translateY(-3px);
        box-shadow: 0 12px 28px rgba(0, 0, 0, 0.2) !important;

        &::before {
          width: 300px;
          height: 300px;
        }
      }

      &:active {
        transform: translateY(-1px);
      }

      .v-icon {
        margin-right: 8px;
      }
    }
  }

  // ============ RESPONSIVE DESIGN ============
  @media (max-width: 960px) {
    padding: 16px;

    .header-card {
      margin-bottom: 20px;

      .header-title {
        font-size: 28px !important;
      }

      .header-subtitle {
        font-size: 15px !important;
      }
    }

    .info-box {
      padding: 16px !important;
      margin-bottom: 12px;

      .info-icon {
        min-width: 42px !important;
        min-height: 42px !important;
      }

      .info-content {
        .info-value {
          font-size: 16px !important;
        }
      }
    }

    .message-wrapper {
      .message-bubble {
        max-width: 80% !important;
        font-size: 14px;
      }
    }

    .section-title {
      font-size: 18px !important;
    }

    ::v-deep .v-btn {
      font-size: 12px !important;
      padding: 0 16px !important;
    }
  }

  @media (max-width: 600px) {
    padding: 12px;

    .header-card {
      border-radius: 16px;
      margin-bottom: 16px;

      .header-content {
        padding: 20px 16px !important;
      }

      .header-icon-box {
        width: 56px;
        height: 56px;
        padding: 10px;
        margin-right: 12px;

        .v-icon {
          font-size: 28px !important;
        }
      }

      .header-title {
        font-size: 24px !important;
        letter-spacing: 0.4px;
      }

      .header-subtitle {
        font-size: 13px !important;
        letter-spacing: 0.2px;
      }

      .action-btn {
        margin-left: 8px !important;
      }
    }

    .info-card {
      border-radius: 14px;
      padding: 16px !important;

      .info-box {
        padding: 14px !important;
        margin-bottom: 10px;
        border-radius: 10px;

        .info-icon {
          min-width: 38px !important;
          min-height: 38px !important;
          margin-right: 12px;
          border-radius: 8px;
        }

        .info-content {
          .info-label {
            font-size: 9px !important;
          }

          .info-value {
            font-size: 14px !important;
          }
        }
      }

      .detail-box {
        padding: 14px !important;
        border-radius: 10px;
        margin-bottom: 12px;

        .detail-label {
          font-size: 10px !important;
          margin-bottom: 8px;
        }

        .detail-value {
          font-size: 14px !important;
        }
      }

      .attachments-container {
        .attachment-img {
          width: 80px !important;
          height: 80px !important;
          border-radius: 8px;
        }
      }
    }

    .messages-card {
      border-radius: 14px;
      padding: 16px !important;

      .chat-container {
        max-height: 400px !important;
        padding: 12px 4px;
        gap: 12px;
      }

      .message-wrapper {
        .message-bubble {
          max-width: 90% !important;
          font-size: 13px;
          border-radius: 14px 14px 4px 14px;
          padding: 12px 14px;

          .message-header {
            font-size: 10px !important;
            margin-bottom: 6px;
          }

          .message-content {
            font-size: 13px !important;
            line-height: 1.5;
          }

          .message-attachments {
            gap: 8px;

            .message-img {
              width: 75px !important;
              height: 75px !important;
              border-radius: 8px;
            }
          }
        }
      }
    }

    .reply-card {
      border-radius: 14px;
      padding: 16px !important;

      .form-field-wrapper {
        .form-label {
          font-size: 11px !important;
          margin-bottom: 8px;
        }

        .notes-text {
          font-size: 10px !important;
        }
      }

      .preview-empty {
        padding: 24px 16px !important;
        border-radius: 10px;
      }

      .preview-box {
        border-radius: 10px;
        padding: 10px;
      }

      ::v-deep .v-btn {
        width: 100% !important;
        margin-bottom: 8px !important;
        font-size: 11px !important;
        padding: 12px 16px !important;
        border-radius: 10px !important;

        .v-icon {
          font-size: 18px !important;
        }
      }
    }

    .section-title {
      font-size: 16px !important;
      margin-bottom: 16px;
      padding-bottom: 12px;
    }

    .text-right {
      justify-content: flex-start;
      gap: 8px;

      .action-btn {
        width: 40px !important;
        height: 40px !important;
      }
    }
  }

  @media (max-width: 400px) {
    padding: 8px;

    .header-card {
      margin-bottom: 12px;

      .header-title {
        font-size: 20px !important;
      }

      .header-subtitle {
        font-size: 12px !important;
      }
    }

    .message-wrapper {
      .message-bubble {
        max-width: 95% !important;
        font-size: 12px;
      }
    }

    ::v-deep .v-btn {
      font-size: 10px !important;
      padding: 8px 12px !important;
    }
  }

  // ============ UTILITY CLASSES ============
  .preview-content {
    font-size: 14px;
    font-weight: normal;
    line-height: 1.5em;
  }

  .text-right {
    text-align: right;
  }

  .d-flex {
    display: flex;
  }

  .justify-content-center {
    justify-content: center;
  }

  .mb-3 {
    margin-bottom: 12px;
  }

  .mb-6 {
    margin-bottom: 24px;
  }

  .mt-4 {
    margin-top: 16px;
  }

  .mt-6 {
    margin-top: 24px;
  }

  .mr-2 {
    margin-right: 8px;
  }

  .ml-2 {
    margin-left: 8px;
  }

  .ml-4 {
    margin-left: 16px;
  }

  .align-center {
    align-items: center;
  }
}
</style>